import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Box,
  Button,
  Grid,
  Stack,
  Typography,
  Alert,
  Tooltip
} from '@mui/material';
import { randomId } from '@mui/x-data-grid-generator';
import {
  GridRowModes,
  GridRowEditStopReasons,
  GridActionsCellItem,
  GridToolbarContainer,
  GridEventListener,
  GridPreProcessEditCellProps,
  GridEditInputCell,
  GridRenderEditCellParams,
  useGridApiContext
} from '@mui/x-data-grid-pro';
import { useEffect, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import { DataTable } from '@pihealth/common-ui-library';
import AppModal from 'src/components/modal';
import { useAppSelector } from 'src/store';
import { useGetAllDepotsMutation, useGetStudyDetailsQuery } from 'src/services/DrugSupply';
import { useUser } from 'src/components/hooks/useUser';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { setMessage } from 'src/store/Message';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import isEqual from 'lodash/isEqual';
import { useUtil } from 'src/components/hooks/useUtil';
import './BlurModalFix.scss';
import { SERVER_DATE_FORMAT } from 'src/constants/formats';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

const ManualEntryDrugSupply = (props: any) => {
  const {
    manualEntryPopup,
    setManualEntryPopup,
    CreateBulkDrugSuppplyQuery,
    drugSupplyDataIsSuccess,
    drugSupplyData,
    isEdit,
    CSVRecords,
    UpdateBulkDrugSuppplyQuery,
    setIsEdit
  } = props;
  const [rows, setRows] = useState<any>([]);
  const [depotName, setDepotName] = useState('');
  const [depotCountry, setDepotCountry] = useState('');
  const [deportId, setDeportId] = useState<any>();
  const [rowModesModel, setRowModesModel] = useState<any>({});
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const selectedStudy: any = useAppSelector(state => state.site.selectedStudy);
  const [deleteId, setDeleteId] = useState<any>();
  const [totalItem, setTotalItem] = useState<any>();
  const [isChange, setIsChange] = useState(false);
  const [totalQuantity, setTotalQuantity] = useState<any>();
  const [totalCost, setTotalCost] = useState<any>();
  const [userName, setUserName] = useState<any>('');
  const [date, setDate] = useState<any>('');
  const [isDisabled, setIsDisabled] = useState(false);
  const [currency, setCurrency] = useState<any>([]);
  const [oldData, setOldData] = useState<any>([]);
  const { user } = useUser();
  const dispatch = useDispatch();
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const { handleError } = useUtil();
  const [Error, setError] = useState(true);
  const [transferError, setTransferError] = useState(false);
  const [dateError, setDateError] = useState(false);
  const [hasEarlyInvalidRowDate, setHasEarlyInvalidRowDate] = useState(false);
  const [hasLatestInvalidRowDate, setHasLatestInvalidRowDate] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [transferQuantity, setTransferQuantity] = useState(0);
  const [quantityRetained, setQuantityRetained] = useState(0);
  const [oldQuanityRetained, setOldQuantityRetained] = useState(0);
  const { getServerDateFormat } = usePreferedDateFormat();
  const { checkPermission } = usePermissionWrapper();

  const handleDepotNameChange = (e: any) => {
    setIsDisabled(false);
    setDepotName(e.target.value);
    setDepotCountry(depotsData?.find((item: any) => item.depot_id == e.target.value)?.depot_country);
    setDeportId(depotsData?.find((item: any) => item.depot_id == e.target.value)?.depot_id);
  };

  const {
    data: getStudyDetailsData,
    error: getStudyDetailsError,
    isError: getStudyDetailsIsError
  } = useGetStudyDetailsQuery({
    study_id: selectedStudy,
    application: 'SYSADMIN',
    application_section: 'SYSADMIN',
    application_module_section: 'Master List'
  });

  const [getAllDepots, { data: depotsData, isError: depotsDataIsError, error: deportDataError }] =
    useGetAllDepotsMutation();

  useEffect(() => {
    if (depotsDataIsError || getStudyDetailsIsError) {
      const err: any = getStudyDetailsError || deportDataError;
      handleError(err);
    }
  }, [depotsDataIsError, getStudyDetailsIsError]);

  const uniqueArray = depotsData?.find((item: { depot_id: any }) => item?.depot_id === deportId)?.depot_ip_name;
  const splitedArray = uniqueArray?.split(',');
  const customNames = [...new Set(splitedArray)];

  const dataArray: any[] = customNames.flatMap((customName: any) =>
    getStudyDetailsData?.study_investigational_products_details
      ?.filter((item: { custom_name: string }) => item.custom_name === customName)
      .map(
        (item: { custom_name: any; cost: any; investigational_drug: any; unit: any; dose: any; cost_unit: any }) => ({
          custom_name: item.custom_name,
          cost_unit: item.cost,
          investigational_drug: item.investigational_drug,
          dose_unit: item.unit,
          dose: item.dose,
          cost_currency: item.cost_unit
        })
      )
  );

  function GridEditDateCell({ id, field, value, colDef }: GridRenderEditCellParams<any>) {
    const [error, setError] = useState(false);
    const apiRef = useGridApiContext();
    const handleChange = (newValue: any) => {
      if (moment(newValue?.$d).isValid() && newValue !== null) {
        apiRef.current.setEditCellValue({ id, field, value: newValue });
      } else if (newValue === null) {
        apiRef.current.setEditCellValue({ id, field, value: null });
      }
    };
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={value ?? null}
          onChange={newValue => handleChange(newValue)}
          key={`Manual-Drug-Supply-Add-Edit-${field}`}
          inputFormat={userPreferedDateFormat.toUpperCase()}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              error={error}
              onBlur={e => {
                const value = e.target.value;
                if (value && !moment(value, userPreferedDateFormat?.toUpperCase(), true).isValid()) {
                  field === 'earliest_expiration_date'
                    ? setHasEarlyInvalidRowDate(true)
                    : setHasLatestInvalidRowDate(true);
                  setError(true);
                } else {
                  field === 'earliest_expiration_date'
                    ? setHasEarlyInvalidRowDate(false)
                    : setHasLatestInvalidRowDate(false);
                  setError(false);
                }
              }}
            />
          )}
        />
      </LocalizationProvider>
    );
  }

  const drugSupplyColumns: any = [
    {
      field: 'custom_name',
      renderHeader: () => (
        <Box sx={{ fontSize: '0.9rem' }}>
          {'Custom Name'}
          <span style={{ color: 'red' }}>&nbsp;*</span>
        </Box>
      ),
      valueGetter: (params: { row: { custom_name: any } }) => params.row.custom_name || '',
      minWidth: 164,
      flex: 1,
      editable: true,
      type: 'singleSelect',
      renderEditCell: (params: any) => {
        const { formattedValue, field, id } = params;
        // Check if custom_name is empty
        const hasError = field === 'custom_name' && (formattedValue === undefined || formattedValue === '');
        const selectedValue = params?.formattedValue || ''; // Use selectedValue to ensure it's defined
        return (
          <Stack direction={'column'} sx={{ width: '100%' }}>
            <Select
              fullWidth
              sx={{
                py: 1,
                '& .MuiSelect-select ~ .MuiOutlinedInput-notchedOutline': { borderBottom: 'none !important' }
              }}
              value={selectedValue}
              required
              onChange={e => {
                const selectedValue = e.target.value;
                setError(params?.row?.quantity ? false : true);
                // Update the corresponding custom_name in the rows state
                const costPerUnitArray = dataArray
                  .filter((item: { custom_name: any }) => item?.custom_name === selectedValue)
                  .map((item: { cost_unit: any }) => item.cost_unit);
                const InvestigationalDrug = dataArray
                  .filter((item: { custom_name: any }) => item?.custom_name === selectedValue)
                  .map((item: { investigational_drug: any }) => item.investigational_drug);
                const doseUnit = dataArray
                  .filter((item: { custom_name: any }) => item?.custom_name === selectedValue)
                  .map((item: { dose_unit: any }) => item.dose_unit);
                const dose = dataArray
                  .filter((item: { custom_name: any }) => item?.custom_name === selectedValue)
                  .map((item: { dose: any }) => item.dose);
                const currency = dataArray
                  .filter((item: { custom_name: any }) => item?.custom_name === selectedValue)
                  .map((item: { cost_currency: any }) => item.cost_currency);
                const updatedRows = rows.map((row: any) =>
                  row.id === id
                    ? {
                        ...row,
                        custom_name: selectedValue,
                        cost_per_unit: costPerUnitArray.length > 0 ? costPerUnitArray[0] : null,
                        investigational_drug: InvestigationalDrug.length > 0 ? InvestigationalDrug[0] : null,
                        dose_unit: doseUnit.length > 0 ? doseUnit[0] : null,
                        dose: dose.length > 0 ? dose[0] : null,
                        currency: currency.length > 0 ? currency[0] : null
                      }
                    : row
                );
                setOldData(rows);
                setRows(updatedRows);
                params = { ...params, error: hasError };
              }}
            >
              {customNames.map((name: any) => {
                return (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                );
              })}
            </Select>
          </Stack>
        );
      }
    },
    {
      field: 'investigational_drug',
      headerName: 'Investigational Drug',
      width: 140,
      sx: { border: '2px solid #4a90e2' },
      valueGetter: (params: { row: { custom_name: any } }) => {
        const InvestigationalDrug = dataArray
          .filter((item: { custom_name: any }) => item?.custom_name === params.row?.custom_name)
          .map((item: { investigational_drug: any }) => item?.investigational_drug);
        // Assuming you want to return the first element of the costPerUnitArray
        return InvestigationalDrug.length ? InvestigationalDrug[0] : null;
      }
    },
    {
      field: 'cost_per_unit',
      headerName: 'Cost Per Unit',
      width: 100,
      sx: { border: '2px solid #4a90e2' },
      valueGetter: (params: { row: { custom_name: any } }) => {
        const costPerUnitArray = dataArray
          .filter((item: { custom_name: any }) => item?.custom_name === params.row?.custom_name)
          .map((item: { cost_unit: any }) => item?.cost_unit);
        // Assuming you want to return the first element of the costPerUnitArray
        return costPerUnitArray.length ? costPerUnitArray[0] : null;
      }
    },
    {
      field: 'quantity',
      renderHeader: () => (
        <Tooltip
          title="Quantity available at this Depot"
          placeholder="bottom"
          arrow
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -24]
                  }
                }
              ]
            }
          }}
        >
          <Box sx={{ fontSize: '0.9rem' }}>
            {'Quantity'}
            <span style={{ color: 'red' }}>&nbsp;*</span>
          </Box>
        </Tooltip>
      ),
      width: 100,
      sx: { border: '2px solid #4a90e2' },
      editable: checkPermission(`ship_drug_supply`) && isEdit ? false : true,
      type: 'number',
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const hasError =
          params.props.value == 0 ||
          params.props.value === undefined ||
          params.props.value === '' ||
          params.props.value === null;
        setQuantity(params.props.value);
        setError(hasError);
        return { ...params.props, error: hasError };
      },
      valueFormatter: (params: any) => {
        return params.value;
      },
      valueGetter: (params: { row: { quantity: any } }) => {
        return params.row.quantity;
      },
      renderEditCell: (params: any) => {
        return (
          <GridEditInputCell
            {...params}
            inputProps={{
              maxLength: 5,
              sx: { border: '2px solid #4a90e2' }
            }}
            type="tel"
            onKeyDown={(e: any) => {
              const charCode = e.which ? e.which : e.keyCode;
              if (
                (charCode > 40 && (charCode < 48 || charCode > 57)) ||
                ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')'].includes(e.key)
              ) {
                e.preventDefault();
              }
            }}
          />
        );
      }
    },
    {
      field: 'quantity_retained',
      headerName: 'Quantity Retained',
      description: 'Quantity withheld at this Depot',
      width: 160,
      sx: { border: '2px solid #4a90e2' },
      editable: true,
      type: 'number',
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        setQuantityRetained(params.props.value);
        return { ...params.props };
      },
      valueFormatter: (params: any) => {
        return params.value;
      },
      valueGetter: (params: { row: { quantity_retained: any } }) => {
        return params.row.quantity_retained;
      },
      renderEditCell: (params: any) => {
        return (
          <GridEditInputCell
            {...params}
            inputProps={{
              maxLength: 5,
              sx: { border: '2px solid #4a90e2' }
            }}
            type="tel"
            onKeyDown={(e: any) => {
              const charCode = e.which ? e.which : e.keyCode;
              if (
                (charCode > 40 && (charCode < 48 || charCode > 57)) ||
                ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')'].includes(e.key)
              ) {
                e.preventDefault();
              }
            }}
          />
        );
      }
    },
    {
      field: checkPermission(`ship_drug_supply`) && isEdit ? 'total_shipped_quantity' : 'transfer_quantity',
      renderHeader: () => (
        <Tooltip
          title={
            checkPermission(`ship_drug_supply`) && isEdit
              ? 'Quantity of Drug being Shipped from this Depot'
              : 'Quantity of Drug being transferred from this Depot'
          }
          placeholder="bottom"
          arrow
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -24]
                  }
                }
              ]
            }
          }}
        >
          <Box sx={{ fontSize: '0.9rem' }}>
            {checkPermission(`ship_drug_supply`) && isEdit ? 'Total Shipped Quantity' : 'Transfer Quantity'}
            {!checkPermission(`ship_drug_supply`) || (!isEdit && <span style={{ color: 'red' }}>&nbsp;*</span>)}
          </Box>
        </Tooltip>
      ),
      width: 160,
      sx: { border: '2px solid #4a90e2' },
      editable: checkPermission(`ship_drug_supply`) && isEdit ? false : isEdit,
      type: 'number',
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const hasError =
          // params.props.value == 0 ||
          params.props.value === undefined || params.props.value === '' || params.props.value === null;
        setTransferQuantity(params.props.value);
        setTransferError(hasError);
        return { ...params.props, error: hasError };
      },
      valueFormatter: (params: any) => {
        return params.value;
      },
      renderEditCell: (params: any) => {
        return (
          <GridEditInputCell
            {...params}
            inputProps={{
              maxLength: 5
            }}
            type="tel"
            onKeyDown={(e: any) => {
              const charCode = e.which ? e.which : e.keyCode;
              if (
                (charCode > 40 && (charCode < 48 || charCode > 57)) ||
                ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')'].includes(e.key)
              ) {
                e.preventDefault();
              }
            }}
          />
        );
      }
    },
    {
      field: 'dose',
      headerName: 'Dose',
      width: 100,
      sx: { border: '2px solid #4a90e2' },
      type: 'number',
      valueGetter: (params: { row: { custom_name: any } }) => {
        const dose = dataArray
          .filter((item: { custom_name: any }) => item?.custom_name === params.row?.custom_name)
          .map((item: { dose: any }) => item.dose);
        // Assuming you want to return the first element of the costPerUnitArray
        return dose.length > 0 ? dose[0] : null;
      }
    },
    {
      field: 'dose_unit',
      headerName: 'Dose Unit',
      width: 100,
      sx: { border: '2px solid #4a90e2' },
      type: 'singleSelect',
      valueGetter: (params: { row: { custom_name: any } }) => {
        const doseUnit = dataArray
          .filter((item: { custom_name: any }) => item?.custom_name === params.row?.custom_name)
          .map((item: { dose_unit: any }) => item.dose_unit);
        // Assuming you want to return the first element of the costPerUnitArray
        return doseUnit.length > 0 ? doseUnit[0] : null;
      }
    },
    {
      field: 'manufacturer',
      headerName: 'Manufacturer',
      minWidth: 120,
      flex: 1,
      editable: true,
      renderEditCell: (params: any) => (
        <GridEditInputCell
          {...params}
          inputProps={{
            maxLength: 50,
            sx: { border: '2px solid #4a90e2' }
          }}
        />
      )
    },
    {
      field: 'manufacturing_lot',
      headerName: 'Manufacturing Lot #',
      minWidth: 150,
      flex: 1,
      editable: true,
      renderEditCell: (params: any) => (
        <GridEditInputCell
          {...params}
          inputProps={{
            maxLength: 40,
            sx: { border: '2px solid #4a90e2' }
          }}
        />
      )
    },
    {
      field: 'packaging_lot',
      headerName: 'Packaging Lot #',
      minWidth: 150,
      flex: 1,
      editable: true,
      renderEditCell: (params: any) => (
        <GridEditInputCell
          {...params}
          inputProps={{
            maxLength: 40,
            sx: { border: '2px solid #4a90e2' }
          }}
        />
      )
    },
    {
      field: 'earliest_expiration_date',
      headerName: 'Earliest Expiration Date',
      type: 'date',
      minWidth: 180,
      editable: true,
      renderEditCell: (params: any) => {
        return <GridEditDateCell {...params} />;
      },
      valueFormatter: (params: any) => {
        if (params?.value !== null) {
          const typeOfParamValue = typeof params?.value;
          const value = typeOfParamValue === 'object' ? params?.value.$d : params?.value;
          if (value !== undefined) {
            if (moment(value).isValid()) {
              return `${moment(value).format(`${userPreferedDateFormat.toUpperCase()}`)}`;
            } else if (moment(value, 'D/M/YYYY', true).isValid()) {
              return `${moment(value, 'D/M/YYYY', true).format(`${userPreferedDateFormat.toUpperCase()}`)}`;
            }
          }
        }
      },
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const hasError =
          params.otherFieldsProps?.latest_expiration_date.value && params.props.value
            ? moment(params.props.value && params.props.value ? params.props.value : params.props.value) >
              moment(
                params.otherFieldsProps?.latest_expiration_date.value
                  ? params.otherFieldsProps?.latest_expiration_date.value
                  : params.otherFieldsProps?.latest_expiration_date.value
              )
            : false;
        setDateError(hasError);
        return { ...params.props, error: hasError };
      }
    },

    {
      field: 'latest_expiration_date',
      headerName: 'Latest Expiration Date',
      type: 'date',
      minWidth: 180,
      editable: true,
      renderEditCell: (params: any) => {
        return <GridEditDateCell {...params} />;
      },
      valueFormatter: (params: any) => {
        if (params?.value !== null) {
          const typeOfParamValue = typeof params?.value;
          const value = typeOfParamValue === 'object' ? params?.value.$d : params?.value;
          if (value !== undefined) {
            if (moment(value).isValid()) {
              return `${moment(value).format(`${userPreferedDateFormat.toUpperCase()}`)}`;
            } else if (moment(value, 'D/M/YYYY', true).isValid()) {
              return `${moment(value, 'D/M/YYYY', true).format(`${userPreferedDateFormat.toUpperCase()}`)}`;
            }
          }
        }
      },
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const hasError =
          params.otherFieldsProps?.earliest_expiration_date.value && params.props.value
            ? moment(params.props.value && params.props.value ? params.props.value : params.props.value) <
              moment(
                params.otherFieldsProps?.earliest_expiration_date.value
                  ? params.otherFieldsProps?.earliest_expiration_date.value
                  : params.otherFieldsProps?.earliest_expiration_date.value
              )
            : false;
        setDateError(hasError);
        return { ...params.props, error: hasError };
      }
    },
    {
      field: 'number_of_kits',
      headerName: 'Number of Kits',
      minWidth: 120,
      sx: { border: '2px solid #4a90e2' },
      flex: 1,
      editable: true,
      valueFormatter: (params: any) => {
        return params.value;
      },
      renderEditCell: (params: any) => {
        return (
          <GridEditInputCell
            {...params}
            inputProps={{
              maxLength: 5,
              sx: { border: '2px solid #4a90e2' }
            }}
            type="tel"
            onKeyDown={(e: any) => {
              const charCode = e.which ? e.which : e.keyCode;
              if (
                (charCode > 40 && (charCode < 48 || charCode > 57)) ||
                ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')'].includes(e.key)
              ) {
                e.preventDefault();
              }
            }}
          />
        );
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 80,
      type: 'actions',
      cellClassName: 'actions',
      renderCell: (params: any) => {
        const id = params.id;
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: 'primary.main',
                fontSize: '1.5rem'
              }}
              key={id}
              size="medium"
              disabled={
                !params.row.custom_name || (checkPermission(`ship_drug_supply`) ? false : Error) || transferError
              }
              onClick={handleSaveClick(params, id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              sx={{
                color: 'primary.main',
                fontSize: '1.5rem'
              }}
              onClick={handleCancelClick(id)}
              key={id}
              size="medium"
            />
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            onClick={handleEditClick(id)}
            disabled={Object.keys(rowModesModel).length > 0}
            key={id}
            sx={{
              color: 'primary.main'
            }}
            size="medium"
          />,
          !isEdit && (
            <GridActionsCellItem
              key={id}
              icon={<DeleteIcon />}
              label="Delete"
              onClick={handleDeleteClick(id)}
              disabled={Object.keys(rowModesModel).length > 0}
              sx={{
                color: 'primary.main'
              }}
              size="medium"
            />
          )
        ];
      }
    }
  ];

  useEffect(() => {
    if (CSVRecords && CSVRecords?.length) {
      if (depotsData) {
        const find = depotsData.find(
          (ele: any) =>
            ele.depot_name === CSVRecords?.[0].depot_name &&
            ele.depot_country === CSVRecords?.[0].depot_country &&
            ele.depot_id === CSVRecords?.[0].depot_id
        );
        if (find) {
          setDepotName(find.depot_id);
          setDepotCountry(find.depot_country);
          setDeportId(find.depot_id);
          const dateEntered = moment().format(userPreferedDateFormat.toUpperCase());
          setDate(dateEntered);
          setIsDisabled(false);
          setRows(
            CSVRecords.map((ele: any) => {
              return { ...ele, id: crypto.randomUUID() };
            })
          );
        }
      }
    }
  }, [CSVRecords, depotsData]);

  useEffect(() => {
    getAllDepots({
      study_id: selectedStudy,
      application: 'SYSADMIN',
      application_section: 'SYSADMIN',
      application_module_section: 'Master List of Studies'
    });
  }, [selectedStudy]);

  useEffect(() => {
    const hasEditMode: boolean = Object.values(rowModesModel).some((item: any) => item.mode === 'edit');
    if (hasEditMode) {
      setRows([]);
      setRowModesModel({});
      setOldData([]);
    }
  }, [depotName]);

  useEffect(() => {
    if (rows.length) {
      if (Object.keys(rowModesModel).length) {
        setIsDisabled(true);
      } else {
        setIsDisabled(false);
      }
    }
  }, [rowModesModel]);

  useEffect(() => {
    if (depotName) {
      if (rows.length < 1) {
        setIsDisabled(false);
      }
    }
    const savedRows = rows.filter((row: { id: string; isNew: boolean }) => {
      return row && !row?.isNew;
    });
    if (savedRows.length > 0) {
      setTotalItem(savedRows?.length);
      const sumOfQuantity = savedRows?.reduce((total: any, item: { quantity: any }) => total + (item.quantity || 0), 0);
      setTotalQuantity(sumOfQuantity);
      setUserName(
        isEdit && !isChange ? (savedRows[0].updated_by ? savedRows[0].updated_by : savedRows[0].created_by) : user
      );
      const totalCost = savedRows.reduce((sum: number, { cost_per_unit = 0, quantity = 0 }: any) => {
        return sum + cost_per_unit * quantity;
      }, 0);
      setTotalCost(totalCost);
      const costCurrency = savedRows.map((item: { currency: any }) => {
        return item.currency;
      });
      const uniqueCostCurrencies: any = [...new Set(costCurrency)];
      setCurrency(uniqueCostCurrencies);
    } else {
      setTotalItem(null);
      setTotalQuantity(null);
      setUserName(null);
      setTotalCost(null);
      setCurrency('');
    }

    if (!rows?.length) {
      setDate('');
    }
  }, [rows, rowModesModel]);

  useEffect(() => {
    if (drugSupplyDataIsSuccess) {
      setRows(drugSupplyData);
      setOldData(drugSupplyData);
      setDepotCountry(drugSupplyData[0].depot_country);
      setDepotName(drugSupplyData[0].depot_id);
      setDeportId(drugSupplyData[0].depot_id);
      setUserName(drugSupplyData[0].updated_by ? drugSupplyData[0].updated_by : drugSupplyData[0].created_by);
      setQuantity(drugSupplyData[0]?.quantity);
      setTransferQuantity(drugSupplyData[0]?.transfer_quantity);
      setQuantityRetained(drugSupplyData[0]?.quantity_retained);
      setOldQuantityRetained(drugSupplyData[0]?.quantity_retained);
    }
  }, [drugSupplyDataIsSuccess]);

  function EditToolbar(setRows: any, setRowModesModel: any, isEdit: boolean) {
    const handleClick = () => {
      setHasEarlyInvalidRowDate(false);
      setHasLatestInvalidRowDate(false);
      setError(true);
      const id = randomId();
      setRows((oldRows: any) => [{ id, custom_name: '', isNew: true }, ...oldRows]);
      setRowModesModel((oldModel: any) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: 'custom_name' }
      }));
    };

    return (
      !isEdit && (
        <GridToolbarContainer>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            sx={{ mx: 0.5, mt: 0.5, mb: 1 }}
            onClick={handleClick}
            disabled={!depotName || isDisabled}
          >
            Add Row
          </Button>
        </GridToolbarContainer>
      )
    );
  }

  const handleRowEditStop: GridEventListener<'rowEditStop'> = (params: any, event: any) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id: any) => () => {
    setHasEarlyInvalidRowDate(false);
    setHasLatestInvalidRowDate(false);
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (params: any, id: any) => () => {
    const dateEntered = moment().format(userPreferedDateFormat.toUpperCase());
    setDate(dateEntered);
    if (hasEarlyInvalidRowDate || hasLatestInvalidRowDate) {
      dispatch(
        setMessage({
          msgDetails: `Please enter valid ${
            hasEarlyInvalidRowDate ? 'Early Expiration' : hasLatestInvalidRowDate ? 'Latest Expiration' : ''
          } date`,
          severity: 'error'
        })
      );
      return;
    }
    if (dateError) {
      dispatch(
        setMessage({
          msgDetails: 'Latest expiration date should be greater than the earliest expiration date',
          severity: 'error'
        })
      );
      return;
    }

    if (quantity < transferQuantity && !(checkPermission(`ship_drug_supply`) && isEdit)) {
      dispatch(
        setMessage({
          msgDetails: 'The transfer quantity cannot exceed the quantity',
          severity: 'error'
        })
      );
      return;
    }
    if (quantity < quantityRetained && checkPermission(`ship_drug_supply`) && isEdit) {
      dispatch(
        setMessage({
          msgDetails: 'Quantity Retained cannot be greater than Quantity',
          severity: 'error'
        })
      );
      return;
    } else {
      if (checkPermission(`ship_drug_supply`) && isEdit) {
        const updatedRow = { ...params.row };
        updatedRow.quantity = quantity - (quantityRetained - oldQuanityRetained);
        setOldQuantityRetained(quantityRetained);
        setQuantity(updatedRow.quantity);
        params.row = updatedRow;
        setRows([updatedRow]);
      }
    }

    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    const hasError = params.value === undefined || params.value === '';
    return { ...params, error: hasError };
  };

  const handleDeleteClick = (id: any) => () => {
    setDeletePopup(true);
    setDeleteId(id);
  };
  const deleteRow = () => {
    setRows(rows.filter((row: any) => row.id != deleteId));
    setOldData(rows.filter((row: any) => row.id != deleteId));
  };
  const handleCancelClick = (id: any) => () => {
    const old = oldData?.map(
      (
        item: {
          custom_name: any;
          cost_per_unit: any;
          investigational_drug: any;
          dose_unit: any;
          dose: any;
          id: any;
        },
        index: string | number
      ) => {
        if (item.id === id) {
          return {
            ...item,
            custom_name: item.custom_name,
            cost_per_unit: item.cost_per_unit,
            investigational_drug: item.investigational_drug,
            dose_unit: item.dose_unit,
            dose: item.dose
          };
        } else {
          return rows[index];
        }
      }
    );
    setRows(old.filter((item: any) => item.custom_name != ''));
    setOldData(old.filter((item: any) => item.custom_name != ''));
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true }
    });
    setDateError(false);
    setTransferError(false);
    setError(true);

    const editedRow = rows.find((row: any) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row: any) => row.id !== id));
    }
  };
  const processRowUpdate = (newRow: any) => {
    oldData?.forEach((row: { id: any }) => {
      if (row.id === newRow.id) {
        const isDataChanged = isEqual(newRow, row);
        if (!isDataChanged) {
          if (!newRow.isNew) {
            //setUserName(user);
            dispatch(setMessage({ msgDetails: 'Data updated successfully', severity: 'success' }));
            setIsChange(true);
          }
        } else {
          dispatch(setMessage({ msgDetails: 'No data modified', severity: 'success' }));
        }
      }
    });
    let updatedRow = newRow;

    rows.map(
      (item: {
        id: any;
        custom_name: any;
        cost_per_unit: any;
        investigational_drug: any;
        dose_unit: any;
        dose: any;
        error: false;
      }) => {
        if (item.id === newRow.id) {
          item?.custom_name
            ? (updatedRow = {
                ...newRow,
                custom_name: item?.custom_name,
                cost_per_unit: item?.cost_per_unit,
                investigational_drug: item?.investigational_drug,
                dose_unit: item?.dose_unit,
                dose: item?.dose,
                isNew: false,
                error: false
              })
            : (updatedRow = {
                ...newRow,
                error: true
              });
        }
      }
    );
    if (!updatedRow.error) {
      const updatedRows = rows.map((row: any) => {
        if (row.id === newRow.id) {
          return updatedRow;
        } else {
          return row;
        }
      });
      setRows(updatedRows);
    }
    setOldData(oldData.map((row: any) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel: any) => {
    if (Object.keys(rowModesModel).length && !Object.keys(newRowModesModel).length) {
      setRowModesModel(newRowModesModel);
    } else {
      return;
    }
  };

  const saveManualEntryData = () => {
    const newRows = rows.map(
      ({
        id,
        isNew,
        error,
        created_on,
        created_by,
        deleted_by,
        deleted_on,
        is_active,
        updated_by,
        updated_on,
        site_id,
        study_id,
        status,
        ...rest
      }: {
        id: string;
        isNew: boolean;
        error: boolean;
        [key: string]: any;
      }) => rest
    );

    const data = newRows.map((item: any) => {
      const earliest_expiration_date =
        item?.earliest_expiration_date &&
        getServerDateFormat(
          typeof item?.earliest_expiration_date === 'object'
            ? moment(item?.earliest_expiration_date.$d).format(SERVER_DATE_FORMAT)
            : item?.earliest_expiration_date
        );

      const latest_expiration_date =
        item?.latest_expiration_date &&
        getServerDateFormat(
          typeof item?.latest_expiration_date === 'object'
            ? moment(item?.latest_expiration_date.$d).format(SERVER_DATE_FORMAT)
            : item?.latest_expiration_date
        );
      return {
        ...item,
        depot_name: depotsData?.find((depot: any) => depot.depot_id === deportId)?.depot_name,
        depot_country: depotCountry,
        depot_id: deportId,
        quantity_retained: Number(item.quantity_retained) || 0,
        earliest_expiration_date,
        latest_expiration_date,
        ...(!isEdit && { created_by: user })
      };
    });

    isEdit
      ? UpdateBulkDrugSuppplyQuery({
          drug_supply_id: rows[0]?.id,
          study_id: selectedStudy,
          application: 'CTMS',
          application_section: process.env.REACT_APP_TUDA_SLUG,
          application_module_section: process.env.REACT_APP_CONDUCT_NAME,
          data: { drug_supply_data: data[0], updated_by: user }
        })
      : CreateBulkDrugSuppplyQuery({
          study_id: selectedStudy,
          application: 'CTMS',
          application_section: process.env.REACT_APP_TUDA_SLUG,
          application_module_section: process.env.REACT_APP_CONDUCT_NAME,
          data: { drug_supply_data: data }
        });
    setRows([]);
    setIsEdit(false);
    setDepotCountry('');
    setDepotName('');
    setDeportId(null);
    setDeleteId(null);
    setManualEntryPopup(false);
    setIsChange(false);
    setOldData([]);
  };
  const closeManualEntry = () => {
    if ((!isEdit && (depotName || rows.length)) || (isEdit && isChange)) {
      setConfirmPopup(true);
    } else {
      resetManualEntryDS();
    }
  };

  const dataTableProps = {
    sx: {
      '& .MuiDataGrid-columnHeaderTitle': {
        fontSize: '0.9rem',
        fontWeight: 600
      },

      '& .MuiDataGrid-main + div .MuiDataGrid-toolbarContainer': {
        borderTop: '1px solid rgba(0,0,0,0.12)'
      },
      '& input': {
        // border: '1px solid #4a90e2 !important',
        padding: '7px!Important',
        borderRadius: '5px',
        '&:hover': {
          backgroundColor: '#efefef'
        },
        '&:focus': {
          outline: 'none',
          border: '2px solid #4a90e2'
        }
      }
    },
    editMode: 'row',
    rowModesModel,
    onRowModesModelChange: handleRowModesModelChange,
    onRowEditStop: handleRowEditStop,
    processRowUpdate,
    experimentalFeatures: { newEditingApi: true },
    componentsProps: {
      toolbar: { setRows, setRowModesModel }
    }
  };
  const resetManualEntryDS = () => {
    setConfirmPopup(false);
    setManualEntryPopup(false);
    setDepotCountry('');
    setDepotName('');
    setDeportId(null);
    setDeleteId(null);
    setRows([]);
    setIsEdit(false);
    setIsChange(false);
    setTotalItem('');
    setTotalQuantity('');
    setUserName('');
    setTotalCost(null);
    setCurrency([]);
    setOldData([]);
    setDateError(false);
    setTransferError(false);
    setError(true);
  };

  return (
    <AppModal
      open={manualEntryPopup}
      title={!isEdit ? 'Entry' : 'Edit'}
      handleSubmit={saveManualEntryData}
      handleClose={closeManualEntry}
      closeButton="Close"
      saveButton={isEdit ? 'Save' : 'Add'}
      maxWidth={1180}
      disabled={isDisabled || !depotName || !rows.length || (isEdit && !isChange)}
      className="modalWithBlurFix"
    >
      <Grid container spacing={3}>
        <Grid item md={6}>
          <FormControl variant="standard" fullWidth>
            <InputLabel id="depot_name_label">Depot Name</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={depotName}
              label="Depot Name"
              onChange={handleDepotNameChange}
              disabled={(rows.length > 1 ? true : rows[0]?.isNew === false) || isEdit}
            >
              {depotsData?.map((item: { depot_name: any; depot_id: any }) => {
                return (
                  <MenuItem value={item.depot_id} key={item.depot_id}>
                    {item.depot_name}-{item.depot_id}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={6}>
          <TextField label="Depot Country" variant="standard" fullWidth value={depotCountry} disabled />
        </Grid>
      </Grid>

      <Box my={2}>
        <DataTable
          height="48.5vh"
          rows={rows}
          columns={
            rows[0]?.status === 'Shipment Requested' || (rows[0]?.status === 'Available' && rows[0]?.shipment_id)
              ? drugSupplyColumns
              : drugSupplyColumns.filter((column: any) => column.field !== 'transfer_quantity')
          }
          dataTableProps={dataTableProps}
          CustomFooter={() => EditToolbar(setRows, setRowModesModel, isEdit)}
          customeMessage={
            <Stack height="80%" alignItems="center" justifyContent="center">
              Click the &quot;Add Row&quot; button
            </Stack>
          }
          hasDefinedColumns
          pinnedColumns={{
            right: ['actions']
          }}
          showMUIFeature={false}
          datePreference={userPreferedDateFormat}
          pagination={false}
          disableRowSelectionOnClick
        />
      </Box>
      <Grid container spacing={3} rowSpacing={2} sx={{ fontSize: '14px' }}>
        <Grid item md={2.6}>
          <Typography variant="body1">
            <strong>Total Cost:</strong>{' '}
            <span className="currencySymbol">
              {isEdit ? rows[0]?.currency : currency?.length > 1 ? null : currency[0]}
            </span>{' '}
            {currency?.length > 1 ? null : totalCost ? parseFloat(totalCost)?.toFixed(3) : totalCost}
          </Typography>
        </Grid>
        <Grid item md={1.6}>
          <strong>Total Item(s):</strong> {rows.length ? totalItem : null}
        </Grid>
        <Grid item md={1.8}>
          <strong>Total Quantity:</strong> {totalItem ? totalQuantity : null}
        </Grid>
        <Grid item md={2.6}>
          <strong>Date Entered:</strong>{' '}
          {isEdit && drugSupplyDataIsSuccess
            ? moment(rows[0]?.created_on).format(userPreferedDateFormat.toUpperCase())
            : totalItem
            ? date
            : CSVRecords?.length
            ? moment(rows[0]?.created_on).format(userPreferedDateFormat.toUpperCase())
            : null}
        </Grid>
        <Grid item md={3.2}>
          <strong>Saved By:</strong> {userName}
        </Grid>
        {currency?.length > 1 && (
          <Grid item md={6}>
            <Alert severity="warning">Total cost is empty due to currency not matching</Alert>
          </Grid>
        )}
      </Grid>

      <AppModal
        open={confirmPopup}
        title={'Confirm'}
        handleClose={resetManualEntryDS}
        handleSubmit={() => {
          setConfirmPopup(false);
        }}
        saveButton={'No'}
        closeButton={'Yes'}
        child
      >
        <Box
          pb={1.5}
        >{`Do you want to close the Entry pop-up screen? If yes, the changes will not be updated on the Drug Supply Record.`}</Box>
      </AppModal>
      <AppModal
        open={deletePopup}
        title={'Confirm'}
        handleClose={() => {
          setDeletePopup(false);
        }}
        handleSubmit={() => {
          setDeletePopup(false);
          deleteRow();
        }}
        saveButton={'Confirm'}
        closeButton={'Cancel'}
        child
      >
        <Box pb={1.5}>{`Are you sure you want to delete the row.`}</Box>
      </AppModal>
    </AppModal>
  );
};

export default ManualEntryDrugSupply;
